/* frontend/src/pages/AdminArticlePage.js */
import React from 'react';
import ArticleForm from '../components/ArticleForm';
import './Blog.css';

const AdminArticlePage = ({ user }) => {
  return <ArticleForm user={user} />;
};

export default AdminArticlePage;
